export default __webpack_public_path__ + "static/media/190629_190332_IMG_9508.6b00b78e.jpg";